import Storage from '../lib/localstorage'
import initialState from '../state'

import { setType } from './types'
import { setProject } from './projects'
import { setHeaders } from './headers'
import { setSegment } from './segments'

export const SET_REPORT = 'export-tool/reports/set-report'
export const FETCH_REPORTS = 'export-tool/reports/fetch-reports'
export const RECEIVE_REPORTS = 'export-tool/reports/fetched-reports'

const storage = new Storage()

export default function reducer(state = {...initialState.reports}, action = {}) {
  const newState = {...state}
  switch (action.type) {
    case SET_REPORT:
      newState.selected = action.payload.report.id
      return newState
      break

    case FETCH_REPORTS:
      newState.fetched = false
      newState.fetching = true
      return newState
      break

    case RECEIVE_REPORTS:
      newState.fetching = false
      newState.fetched = true
      newState.list = action.payload.reports
      return newState
      break

    default:
      return state
      break
  }
}

export function setReport(report) {
  return (dispatch) => {
    dispatch({ type: SET_REPORT, payload: { report } })
    dispatch(setType(report.type))
    dispatch(setProject(report.project))
    dispatch(setHeaders(report.headers))

    if (report.type === 'segments') {
      dispatch(setSegment(report.segment))
    }
  }
}

export function createReport(report) {
  return (dispatch) => {
    storage
    .createReport(report)
    .then(() => {
      dispatch(fetchReports())
    })
    .catch(err => {
      console.log(`[createReport] error: ${err.message}`)
    })
  }
}

export function fetchReports() {
  return (dispatch) => {
    dispatch({ type: FETCH_REPORTS, payload: null })
    storage
    .getReports()
    .then(reports => {
      console.log('GOT REPORTS', reports)
      dispatch(receiveReports(reports))
    })
    .catch(err => {
      console.log(`[fetchReports] error: ${err.message}`)
      dispatch(receiveReports([]))
    })
  }
}

export function receiveReports(reports) {
  return {
    type: RECEIVE_REPORTS,
    payload: {
      reports
    }
  }
}



// WEBPACK FOOTER //
// ./ducks/reports.js